<template lang="pug">
  .component-invoice-list-filter-form.filter-form
    .row.medium-unstack
      .columns
        input(type="text", placeholder="Search by HW Serial", v-model="search.hw_serial", v-on:keyup="enterSubmit")
      .columns
        selectize-category(@optionSelected="selectVehicleCategory")
      .columns
        selectize-vehicle(@optionSelected="selectVehicle", @optionRemoved="unselectVehicle" :archived="search.archived" :key="search.archived")
      .columns
        selectize-vehicle-slot(@optionSelected="selectVehicleSlot", @optionRemoved="unselectVehicleSlot", :placeholder="'Filter vehicle slot'")
      .columns
        select(v-model="search.active")
          option(:value="null") --
          option(:value="true") Disabled
          option(:value="false") Enabled
      .columns
        select(v-model="search.archived")
          option(:value='undefined' selected disabled hidden)  Archived Status
          option(value="ARCHIVED") Archived
          option(value="NOT ARCHIVED") Not Archived
      .columns
        selectize-segment(v-model="search.segment_id", valueField="id")
    .row
      .columns
        select(v-model="search.door_status")
          option(:value='null' selected) Locked Status
          option(value="LOCKED") locked
          option(value="UNLOCKED") unlocked
      .columns
        select(v-model="search.engine_status")
          option(:value='null' selected) Engine Status
          option(value="RUNNING") running
          option(value="NOT RUNNING") not running
      .columns
        select(v-model="search.ev_plug_status")
          option(:value='null' selected) Plug Status
          option(value="CHARGING") charging
          option(value="CONNECTED") connected
          option(value="DISCONNECTED") disconnected
      .columns
        select(v-model="search.door_open_status")
          option(:value='null' selected) Door
          option(value="OPEN") open
          option(value="CLOSED") closed
      .columns
        select(v-model="search.key_status")
          option(:value='null' selected) Key Status
          option(value="PRESENT") present
          option(value="NOT PRESENT") not present
      .columns
        select(v-model="search.immobilizer_status")
          option(:value='null' selected) Immo Status
          option(value="ENABLED") enabled
          option(value="DISABLED") disabled

      .columns
        a.fa.fa-angle-double-down.fa-2x(v-on:click="filterVehicles")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import SelectizeVehicle from "../lists/selectize/SelectizeVehicle";
  import SelectizeVehicleSlot from "../lists/selectize/SelectizeVehicleSlot";
  import SelectizeCategory from "../lists/selectize/SelectizeCategory";
  import SelectizeSegment from "../lists/selectize/SelectizeSegment";
  export default {
    name: "VehicleListForm",
    components: {
      SelectizeSegment,
      SelectizeCategory,
      SelectizeVehicleSlot,
      SelectizeVehicle,
      KeplerBackofficeSdk,
    },
    data() {
      return {
        drivers: [],
        search: {
          vehicle_slot_id: null,
          vehicle_category_id: null,
          vehicle_id: null,
          hw_serial: null,
          active: null,
          segment_id: null,
          engine_status: null,
          immobilizer_status: null,
          door_status: null,
          key_status: null,
          ev_plug_status: null,
          door_open_status: null
        },
      }
    },
    created() {
    },
    computed: {},
    watch: {
      search: {
        handler () {
          this.filterVehicles()
        },
        deep: true
      }
    },
    methods: {
      selectVehicleCategory(category) {
        this.search.vehicle_category_id = category.id
      },
      unselectVehicle() {
        this.search.vehicle_id = null
        this.$emit('filterVehicles', {})
      },
      unselectVehicleSlot() {
        this.search.vehicle_slot_id = null
        this.$emit('filterVehicles', {})
      },
      enterSubmit(e) {
        if (e.keyCode === 13) {
          this.filterVehicles()
        }
      },
      selectVehicle(vehicle, x) {
        this.search.vehicle_id = vehicle.id
      },
      selectVehicleSlot(vehicleSlot) {
        this.search.vehicle_slot_id = vehicleSlot.id
      },
      filterVehicles() {
        const copy = JSON.parse(JSON.stringify(this.search))
        this.$cleanObject(copy)
        this.$emit('filterVehicles', copy)
      },
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// VehicleListForm.vue?15370ed7